import { ThunkType } from "../../../../core/store/reducers";
import createAttributeApi from "../api/createAttribute";
import updateAttributeApi from "../api/updateAttribute";
import { setFetchState } from "../attributeDataReducer";
import { Attribute } from "../types";

export const upsertAttribute = (attribute: Attribute): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return;
	}

	dispatch(setFetchState({ type: "started" }));

	const { userId } = store.data.auth.current.user;
	const result = attribute.attrId
		? await dispatch(updateAttributeApi(userId, attribute))
		: await dispatch(createAttributeApi(userId, attribute));

	if (result && result.resCode === "OK") {
		dispatch(setFetchState({ type: "successful", result: result.resDesc }));
		return result.resDesc;
	} else {
		dispatch(setFetchState({ type: "error", errorCode: result?.resCode }));
	}
};
